import React, { ReactNode } from 'react';
import { useTheme } from '@material-ui/core';

import HeaderFooterShell from '@hydra/common/shell/HeaderFooterShell';
import AccountTabs from './AccountTabs';

const AccountContainer = ({ children, data }: { children: ReactNode, data: { hideTabs: boolean; isCancelFlow: boolean; } | undefined }) => {
  const theme = useTheme();

  return (
    <HeaderFooterShell FooterProps={{ small: !data?.isCancelFlow }} bgColor={!data?.isCancelFlow ? theme.palette.background.secondary : ''}>
      {!data?.hideTabs
        ? (
          <AccountTabs>
            {children}
          </AccountTabs>
          )
        : children}
    </HeaderFooterShell>
  );
};

export default AccountContainer;
